export function clearStoragePreserve(prefixes = []) {
  const keep = [];
  try {
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i);
      if (!key) continue;
      if (prefixes.some((p) => key.startsWith(p))) {
        keep.push([key, window.localStorage.getItem(key)]);
      }
    }
  } catch (_) {
    // ignore enumeration errors
  }

  try {
    window.sessionStorage.clear();
  } catch (_) {
    // ignore
  }

  try {
    window.localStorage.clear();
  } catch (_) {
    // ignore
  }

  for (const [k, v] of keep) {
    try {
      if (v !== null && v !== undefined) window.localStorage.setItem(k, v);
    } catch (_) {
      // ignore restore errors
    }
  }
}

export const RESOLVED_DISPUTE_STORAGE_PREFIXES = [
  'boldd_resolved_dispute_seen_v3_',
  'boldd_resolved_dispute_seen_v2_',
  'resolved_dispute_popup_seen_v3_',
  'resolved_dispute_popup_seen_v2_',
];
